import { getElementRotations } from "../../../utils/canvas/getRotations";
import { getTransformedElement } from "../../../utils/canvas/getTransformedElement";
import config from "../../../utils/config";

const calculateNewPosition = (element, newX, newY) => {
  element.position({
    x: element.x() > newX ? newX : element.x(),
    y: element.y() > newY ? newY : element.y(),
  });
};

export const moveWithInLineEdges = ({
  element,
  canvasTop,
  canvasBottom,
  canvasLeft,
  canvasRight,
  tileGap,
  currentShape,
  handleDragEnd,
  currentEvent,
}) => {
  const { offsetX, offsetY } = getTransformedElement(element);
  const gap = tileGap / config.defaultRatio;

  if (currentShape === "simple") {
    const newX = Math.max(
      gap,
      Math.min(canvasTop - offsetX - gap, element.x())
    );
    const newY = Math.max(
      gap,
      Math.min(canvasLeft - offsetY - gap, element.y())
    );

    calculateNewPosition(element, newX, newY);
  }

  if (currentShape === "left") {
    const isLeftTop = element.x() > canvasBottom - offsetY;
    const isLeftBottom = element.y() > canvasRight - offsetY;

    if (isLeftTop) {
      const newX = Math.max(
        gap,
        Math.min(canvasTop - offsetX - gap, element.x())
      );
      const newY = Math.max(
        gap,
        Math.min(canvasRight - offsetY - gap, element.y())
      );

      calculateNewPosition(element, newX, newY);
    }
    if (isLeftBottom) {
      const newX = Math.max(
        gap,
        Math.min(canvasBottom - offsetX - gap, element.x())
      );
      const newY = Math.max(
        gap,
        Math.min(canvasLeft - offsetY - gap, element.y())
      );

      calculateNewPosition(element, newX, newY);
    }
  }

  if (currentShape === "right") {
    const isLeftTop = element.x() > canvasBottom + offsetX + gap;
    const isRIghtBottom = element.y() > canvasLeft + offsetY - gap;

    if (!isLeftTop && !isRIghtBottom) {
      const newX = Math.max(
        gap,
        Math.min(canvasTop - offsetX - gap, element.x())
      );
      const newY = Math.max(
        gap,
        Math.min(canvasLeft - offsetY - gap, element.y())
      );

      calculateNewPosition(element, newX, newY);
    }

    if (isLeftTop) {
      const newX = Math.max(
        gap,
        Math.min(canvasTop - offsetX - gap, element.x())
      );
      const newY = Math.max(
        gap,
        Math.min(canvasLeft - offsetY - gap, element.y())
      );

      element.position({
        x: element.x() > newX ? newX : element.x(),
        y: element.y() < newY ? newY : element.y(),
      });
    }

    if (isRIghtBottom) {
      const newX = Math.max(canvasBottom + offsetX + gap, gap);
      const newY = Math.max(
        gap,
        Math.min(canvasRight - offsetY - gap, element.y())
      );

      element.position({
        x: element.x() < newX ? newX : element.x(),
        y: element.y() > newY ? newY : element.y(),
      });
      // calculateNewPosition(element, newX, newY);
    }
  }

  setTimeout(() => {
    getElementRotations(
      element,
      currentShape,
      canvasTop,
      canvasLeft,
      canvasRight,
      canvasBottom,
      tileGap
    );
    handleDragEnd(element, false);
  }, 10);
};
